export default __webpack_public_path__ + "static/media/luna.93b51c7d.svg";